import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 门店文章插件，只能到门店独立后台进行文章发布，总后台只能查看
export default [{
  path: "/store/article/index",
  component: function component() {
    return import("../../../views/dev-plug/store-article/index.vue");
  },
  name: "storeArticleIndex",
  meta: {
    title: "",
    foot: true
  }
}];